import { DealCardSkeleton } from "./DealCardSkeleton";

interface DealGridSkeletonProps {
  count?: number;
  className?: string;
  gridClassName?: string;
}

export function DealGridSkeleton({ count = 8, className = "", gridClassName }: DealGridSkeletonProps) {
  const resolvedGridClassName = gridClassName ?? "grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-4";

  return (
    <div className={className}>
      <div className={resolvedGridClassName}>
        {Array.from({ length: count }).map((_, index) => (
          <DealCardSkeleton key={`skeleton-${index}`} />
        ))}
      </div>
    </div>
  );
}
